import { useIsBasic, useIsPro } from "./index";

export const useShowBannerAd = () => {
    const isBasic = useIsBasic();
    const isPro = useIsPro();
    return !isPro && !isBasic;
};
